import { useEffect, useRef, useCallback } from 'react';

const WARN_AT   = 25 * 60 * 1000; // 25 minutes
const LOGOUT_AT = 30 * 60 * 1000; // 30 minutes

export default function useInactivityTimer({ onWarn, onLogout, paused = false }) {
  const warnTimer   = useRef(null);
  const logoutTimer = useRef(null);

  const clearTimers = useCallback(() => {
    clearTimeout(warnTimer.current);
    clearTimeout(logoutTimer.current);
  }, []);

  const resetTimers = useCallback(() => {
    clearTimers();
    if (paused) return; // upload in progress — don't count down
    warnTimer.current   = setTimeout(onWarn,   WARN_AT);
    logoutTimer.current = setTimeout(onLogout, LOGOUT_AT);
  }, [paused, onWarn, onLogout, clearTimers]);

  // Pause/resume when upload state changes
  useEffect(() => {
    if (paused) {
      clearTimers();
    } else {
      resetTimers();
    }
  }, [paused, clearTimers, resetTimers]);

  // Listen for user activity
  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];
    events.forEach(e => window.addEventListener(e, resetTimers, { passive: true }));
    resetTimers(); // kick off on mount
    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimers));
      clearTimers();
    };
  }, [resetTimers, clearTimers]);
}
